import { Modal, Space, Form, Input, Divider, message, Image } from "antd";
import React, { useState, useEffect } from "react";
import { uploadFile, createFlow } from "@/services/common";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "@/AppContext";

type FieldType = {
  name: string;
  description?: string;
  // owner_id: number;
  thumbnail_url?: string | null;
};

const Component = (props: any) => {
  const { status, setStatus, userInfo, loadData, source } = props;
  const [form] = Form.useForm();
  const history = useNavigate();
  const { state, actions } = useAppContext();
  const { setFlowMode, setCurPage } = actions;

  const closeModal = () => {
    setStatus(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [status]);
  const onFinish = (values: FieldType) => {
    const subData = {
      ...values,
      thumbnail_url: null,
    };
    console.log("subData", subData);
    console.log("source.id", source.id);
    createFlow(source.id, subData, userInfo.access_token).then((r: any) => {
      if (r.status === 200) {
        closeModal();
        setFlowMode("新建流程");
        setCurPage({ label: "全局设置", key: "settingMaterial" });
        history(`/project/${r.data.project_id}/flow/${r.data.id}/setting`);
      } else {
        message.error("流程创建失败！");
      }
    });
  };

  return (
    <Modal
      title={
        <Space>
          <div className="t2">{`创建流程`}：</div>
        </Space>
      }
      open={status}
      onOk={closeModal}
      onCancel={closeModal}
      footer={null}
      maskClosable={false}
      destroyOnHidden={true}
      width="55%"
      // afterOpenChange={()=>{

      // }}
      // closeIcon={<CloseCircleFilled style={{ color: '#FFF' }} />}
      //     okText: '确认',
      // cancelText: '取消',
      style={{ top: 40 }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "5rem",
        }}
      >
        <Form
          name="createProject"
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 18 }}
          style={{ width: "70%" }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label={<div className="t3">流程名称</div>}
            name="name"
            rules={[{ required: true, message: "请输入流程名称!" }]}
          >
            <Input size="large" style={{ borderRadius: 0 }} />
          </Form.Item>
          <Form.Item
            label={<div className="t3">流程描述</div>}
            name="description"
          // rules={[{ required: true, message: '请输入项目名称!' }]}
          >
            <Input.TextArea rows={5} />
          </Form.Item>

          <Divider />
          <Form.Item wrapperCol={{ offset: 4, span: 18 }}>
            <Space>
              <div className="button_new" onClick={() => form.submit()}>
                创建流程
              </div>
              <div className="button_cancle_new" onClick={closeModal}>
                关闭
              </div>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default Component;
